export const BreakpointsSearchPageProfileEnum = {
  MobileXS: 350,
  MobileS: 475,
  XXS: 768,
  XS: 768,
  S: 992,
  M: 1200,
  L: 1440,
  XL: 1920,
}
